import Canvas from 'Scripts/classes/Canvas'
import { Plane } from 'ogl'
import NormalizeWheel from 'normalize-wheel'

import Media from './Media'
import { lerp } from 'Scripts/utils/utils'

export default class extends Canvas {
  constructor({ canvas, gallery, medias, cases, wrapper }) {
    super({ canvas })
    //
    this.gallery = gallery instanceof HTMLElement ? gallery : document.querySelector(gallery)
    this.mediaElement = medias instanceof HTMLElement ? medias : document.querySelectorAll(medias)
    this.wrapper = wrapper instanceof HTMLElement ? wrapper : document.querySelector(wrapper)
    this.cases = cases instanceof HTMLElement ? cases : document.querySelectorAll(cases)

    this.scroll = {
      last: 0,
      current: 0,
      target: 0,
      ease: 0.05
    }
    this.speed = 1
    //
    this.createGeometry()
    this.createMedia()
    this.onResize()
    this.addEventListener()
  }

  createGeometry() {
    this.geometry = new Plane(this.gl, {
      widthSegments: 10,
      heightSegments: 10
    })
  }

  createMedia() {
    this.medias = [...this.mediaElement].map(media => new Media({
      media,
      gl: this.gl,
      id : media.dataset.id,
      single : [...this.cases].find(page => page.dataset.id == media.dataset.id),
      geometry: this.geometry,
      scene: this.scene,
      height: this.galleryWidth,
      wrapper : this.wrapper
    }))
  }

  update() {
    super.update()

    if (this.scroll) {
      this.scroll.target += this.speed
      this.scroll.current = lerp(this.scroll.current, this.scroll.target, this.scroll.ease)
      //
      if (this.scroll.current > this.scroll.last) {
        this.direction = 'right'
        this.speed *= 1
      } else if (this.scroll.current < this.scroll.last) {
        this.direction = 'left'
        this.speed *= -1
      }
      //
      this.medias && this.medias.forEach(media => media.update(this.scroll, this.direction))

      this.scroll.last = this.scroll.current
    }

  }

  onResize() {
    super.onResize()
    this.gallery && this.getGalleryBounds()
    this.medias && this.medias.forEach(media => media.onResize(this.gallerySize))
  }

  getGalleryBounds() {
    this.galleryBounds = this.gallery.getBoundingClientRect()
    this.gallerySize = {
      width: this.galleryBounds.width,
      height: this.galleryBounds.height
    }
  }

  addEventListener() {
    // window.addEventListener('scroll',this.onScroll.bind(this))

    window.addEventListener('mousewheel', this.onWheel.bind(this))
    window.addEventListener('wheel', this.onWheel.bind(this))

    window.addEventListener('mousedown', this.onTouchDown.bind(this))
    window.addEventListener('mousemove', this.onTouchMove.bind(this))
    window.addEventListener('mouseup', this.onTouchUp.bind(this))

    window.addEventListener('touchstart', this.onTouchDown.bind(this))
    window.addEventListener('touchmove', this.onTouchMove.bind(this))
    window.addEventListener('touchend', this.onTouchUp.bind(this))
  }


  // onScroll(){
  //   console.log('Scroll event')
  // }

  onWheel(e) {
    const normalized = NormalizeWheel(e)
    const speed = normalized.pixelY
    this.scroll.target += speed * 0.5
  }

  onTouchDown(e) {
    this.isDown = true
    // this.scroll.position = this.scroll.current
    this.start = e.touches ? e.touches[0].clientX : e.clientX
  }

  onTouchMove(e) {
    if (!this.isDown) return
    const x = e.touches ? e.touches[0].clientX : e.clientX
    const distance = (this.start - x) * 2

    this.scroll.target = this.scroll.current + distance
  }

  onTouchUp(e) {
    this.isDown = false
  }

}